
// import React, { useState } from "react";
// import Grid from "@mui/material/Grid";
// import Card from "@mui/material/Card";
// import MDBox from "components/MDBox";
// import MDButton from "components/MDButton";
// import MDSnackbar from "components/MDSnackbar";
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import DataTable from "examples/Tables/DataTable";
// import * as XLSX from "xlsx";
// import _ from "lodash";
// import axios from "axios";
// import Alert from "@mui/material/Alert";
// import { isPhoneNumber } from "config"; 
// import { updateaccount } from "config";

// const roles = ["STUDENT", "STAFF", "DRIVER", "ATTENDANT"];

// function BulkStudentUpload() {
//   const [accountDataSource, setAccountDataSource] = useState([]);
//   const [errorMessage, setErrorMessage] = useState("");
//   const [successSB, setSuccessSB] = useState(false);
//   const [errorSB, setErrorSB] = useState(false);

//   // Snackbar handlers
//   const openSuccessSB = () => setSuccessSB(true);
//   const closeSuccessSB = () => setSuccessSB(false);
//   const openErrorSB = () => setErrorSB(true);
//   const closeErrorSB = () => setErrorSB(false);

//   // Snackbar components
//   const renderSuccessSB = (
//     <MDSnackbar
//       color="success"
//       icon="check"
//       title="Account Action"
//       content="Students Successfully Deleted"
//       dateTime="Just now"
//       open={successSB}
//       onClose={closeSuccessSB}
//       close={closeSuccessSB}
//       bgWhite
//     />
//   );

//   const renderErrorSB = (
//     <MDSnackbar
//       color="error"
//       icon="warning"
//       title="Account Action"
//       content="Failed to delete students. Please try again."
//       dateTime="Just now"
//       open={errorSB}
//       onClose={closeErrorSB}
//       close={closeErrorSB}
//       bgWhite
//     />
//   );

//   // Columns for DataTable
//   const columns = [
//     { Header: "Account Id", accessor: "accountId", width: "15%" },
//     { Header: "Role", accessor: "role", width: "10%" },
//     { Header: "First Name", accessor: "firstName", width: "15%" },
//     { Header: "Last Name", accessor: "lastName", width: "15%" },
//     { Header: "Roll Number", accessor: "extra.rollNumber", width: "15%" },
//     { Header: "RFID Number", accessor: "rfidTag", width: "15%" },
//     { Header: "Standard", accessor: "extra.standard", width: "10%" },
//     { Header: "Guardian Numbers", accessor: "extra.guardians", width: "15%" },
//     { Header: "Address", accessor: "address", width: "20%" },
//   ];

//   // Function to validate and create account data from Excel
//   const createAccountData = (datas) => {
//     let dataSource = [];
//     let invalid = "";
//     let index = 0;
//     let dataIndex = 0;

//     _.map(datas, (json) => {
//       dataIndex += 1;
//       let record = { extra: {} };

//       record.firstName = json["First Name"];
//       record.lastName = json["Last Name"];

//       if (_.size(json["Admission No"]) < 2) {
//         console.log(`Admission number missing at row ${dataIndex}`);
//         setErrorMessage(`Admission number missing at row ${dataIndex}`);
//         invalid += `${dataIndex}, `;
//         return;
//       }
//       if (_.size(json.Role) < 2 || !roles.includes(json.Role)) {
//         console.log(`Account role is missing or invalid at row ${dataIndex}`);
//         setErrorMessage(`Account role is missing or invalid at row ${dataIndex}`);
//         invalid += `${dataIndex}, `;
//         return;
//       }

//       record.accountId = json["Admission No"];
//       record.role = json.Role.toUpperCase();
//       record.rfidTag = json["RFID Number"];
//       record.extra.rollNumber = json["Roll Number"];
//       record.extra.standard = json.Standard;
//       record.address = json.Address;
//       record.extra.guardians = [];

//       if (["DRIVER", "ATTENDANT", "STAFF"].includes(record.role)) {
//         if (isPhoneNumber(record.accountId) && _.size(record.accountId) === 10) {
//           record.phoneNumber = `91${record.accountId}`;
//           record.accountId = record.phoneNumber;
//         }
//         let g = record.extra.guardians;
//         if (record.role === "STAFF" && isPhoneNumber(record.phoneNumber) && !g.includes(record.phoneNumber)) {
//           g.push(record.phoneNumber);
//           record.extra.guardians = g;
//         }
//       }

//       if (json["Guardian Numbers"]) {
//         let numbers = json["Guardian Numbers"].split(";");
//         let numberInvalid = false;
//         numbers.forEach((number) => {
//           number = number.replace(/\s+/, "");
//           if (number.length === 10) {
//             number = `91${number}`;
//           }
//           if (number.length === 12 && isPhoneNumber(number)) {
//             if (!record.extra.guardians.includes(number)) {
//               record.extra.guardians.push(number);
//             }
//           } else {
//             numberInvalid = true;
//           }
//         });

//         if (numberInvalid) {
//           console.log(`Invalid guardian number at row ${dataIndex}`);
//           setErrorMessage(`Invalid guardian number at row ${dataIndex}`);
//           invalid += `${dataIndex}, `;
//           return;
//         }
//       }
//       dataSource[index] = record;
//       index += 1;
//     });

//     if (_.size(invalid) > 0) {
//       setErrorMessage(`Invalid rows found - ${invalid}`);
//       return null;
//     }
//     return dataSource;
//   };

//   // Function to handle file upload
//   const onUpload = (event) => {
//     const file = event.target.files[0];
//     if (!file) return;

//     let reader = new FileReader();
//     reader.onload = (e) => {
//       let data = e.target.result;
//       let workbook = XLSX.read(data, { type: "binary" });
//       let datas = [];
//       let dataJson = [];
//       workbook.SheetNames.forEach((sheetName) => {
//         dataJson = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
//         if (sheetName === "Students") {
//           datas.Students = dataJson;
//         }
//       });

//       let students = createAccountData(datas.Students);
//       if (students) {
//         setAccountDataSource(students);
//         setErrorMessage("");
//       } else {
//         setAccountDataSource([]);
//       }
//     };
//     reader.readAsBinaryString(file);
//   };

//   // Function to handle download template
//   const handleDownloadTemplate = () => {
//     const worksheetData = [
//       [
//         "Admission No",
//         "Role",
//         "First Name",
//         "Last Name",
//         "Roll Number",
//         "RFID Number",
//         "Standard",
//         "Guardian Numbers",
//         "Address",
//       ],
//       [
//         "18PC010010",
//         "STUDENT",
//         "Arun",
//         "Naik",
//         "18PC010010",
//         "12345678",
//         "Grade V",
//         "9645274915;9876543213",
//         "Bits Pilani, Hyderabad",
//       ],
//     ];

//     const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Students");

//     XLSX.writeFile(workbook, "Student-Data-Upload-Template.xlsx");
//   };
//   const handleSubmitChanges = async () => {
//     if (accountDataSource.length === 0) {
//       setErrorMessage("No valid data to submit.");
//       openErrorSB();
//       return;
//     }
  
//     // Construct payload to match the reference handleSubmit structure
//     const payload = {
//       accounts: accountDataSource.map((item) => ({
//         accountId: item.accountId,
//         firstName: item.firstName,
//         lastName: item.lastName,
//         role: item.role,
//         address: item.address,
//         rfidTag: item.rfidTag || null,
//         extra: {
//           standard: item.extra.standard,
//           rollNumber: item.extra.rollNumber,
//           guardians: item.extra.guardians || [],
//         },
//       })),
//     };
  
//     try {
//       const sessionCode = localStorage.getItem("token");
//       if (!sessionCode) {
//         throw new Error("Session code is missing");
//       }
  
//       const response = await axios.post(updateaccount, payload, {
//         headers: {
//           "Content-Type": "application/json",
//           "x-dhundhoo-session": sessionCode,
//         },
//       });
  
//       if (response.status === 200) {
//         openSuccessSB();
//         setAccountDataSource([]); // Clear the table after successful submission
//       } else {
//         console.error("API Error", response);
//         setErrorMessage("Unexpected response from server.");
//         openErrorSB();
//       }
//     } catch (error) {
//       console.error("API Request Failed", error);
//       setErrorMessage("Failed to submit data. Please try again.");
//       openErrorSB();
//     }
//   };
//   // Function to handle submit changes with API call
// //   const handleSubmitChanges = async () => {
// //     if (accountDataSource.length === 0) {
// //       setErrorMessage("No valid data to submit.");
// //       openErrorSB();
// //       return;
// //     }

// //     let payload = accountDataSource.map((item) => item.accountId);

// //     try {
// //       const sessionCode = localStorage.getItem("token");
// //       if (!sessionCode) {
// //         throw new Error("Session code is missing");
// //       }

// //       const response = await axios.post(updateaccount, payload, {
// //         headers: {
// //           "Content-Type": "application/json",
// //           "x-dhundhoo-session": sessionCode,
// //         },
// //       });

// //       if (response.status === 200) {
// //         openSuccessSB();
// //         setAccountDataSource([]); // Clear the table after successful deletion
// //       } else {
// //         console.error("API Error", response);
// //         openErrorSB();
// //       }
// //     } catch (error) {
// //       console.error("API Request Failed", error);
// //       openErrorSB();
// //     }
// //   };

//   return (
//     <DashboardLayout>
//       <DashboardNavbar />
//       <MDBox pt={6} pb={3}>
//         <Grid container spacing={6}>
//           <Grid item xs={12}>
//             <Card>
//               <MDBox
//                 mx={2}
//                 mt={-3}
//                 py={3}
//                 px={2}
//                 variant="gradient"
//                 borderRadius="lg"
//                 coloredShadow="info"
//               >
//                 <Grid
//                   item
//                   xs={12}
//                   sx={{
//                     display: "flex",
//                     gap: 2,
//                     justifyContent: "space-around"
//                     // mt: 3,
//                   }}
//                 >
//                   <MDButton
//                     variant="gradient"
//                     color="info"
//                     onClick={handleDownloadTemplate}
//                   >
//                     Download Template
//                   </MDButton>

//                   <MDButton
//                     variant="gradient"
//                     color="info"
//                     component="label"
//                   >
//                     Upload Data Sheet
//                     <input
//                       type="file"
//                       accept=".xlsx"
//                       hidden
//                       onChange={onUpload}
//                     />
//                   </MDButton>

//                   <MDButton
//                     variant="gradient"
//                     color="info"
//                     onClick={handleSubmitChanges}
//                   >
//                     Submit Changes
//                   </MDButton>
//                 </Grid>
//               </MDBox>

//               {errorMessage && (
//                 <MDBox px={2} pt={2}>
//                   <Alert severity="error">{errorMessage}</Alert>
//                 </MDBox>
//               )}

//               <MDBox pt={3}>
//                 <DataTable
//                   table={{ columns, rows: accountDataSource }}
//                   isSorted={false}
//                   entriesPerPage={false}
//                   showTotalEntries={false}
//                   noEndBorder
//                 />
//               </MDBox>
//             </Card>
//           </Grid>
//         </Grid>
//       </MDBox>
//       {renderSuccessSB}
//       {renderErrorSB}
//     </DashboardLayout>
//   );
// }

// export default BulkStudentUpload;


import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import * as XLSX from "xlsx";
import _ from "lodash";
import axios from "axios";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { isPhoneNumber } from "config"; 
import { updateaccount } from "config";

const roles = ["STUDENT", "STAFF", "DRIVER", "ATTENDANT"];

function BulkStudentUpload() {
  const [accountDataSource, setAccountDataSource] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [successSB, setSuccessSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);
  // Server response after "Submit Changes" ({ message, skippedRfids })
  const [uploadResult, setUploadResult] = useState(null);

  // Snackbar handlers
  const openSuccessSB = () => setSuccessSB(true);
  const closeSuccessSB = () => setSuccessSB(false);
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);

  // Snackbar components
  const renderSuccessSB = (
    <MDSnackbar
      color="success"
      icon="check"
      title="Account Action"
      content={uploadResult?.message || "Accounts saved successfully"}
      dateTime="Just now"
      open={successSB}
      onClose={closeSuccessSB}
      close={closeSuccessSB}
      bgWhite
    />
  );

  const renderErrorSB = (
    <MDSnackbar
      color="error"
      icon="warning"
      title="Account Action"
      content={errorMessage || "Failed to save accounts. Please try again."}
      dateTime="Just now"
      open={errorSB}
      onClose={closeErrorSB}
      close={closeErrorSB}
      bgWhite
    />
  );

  // Columns for DataTable
  const columns = [
    { Header: "Account Id", accessor: "accountId", width: "15%" },
    { Header: "Role", accessor: "role", width: "10%" },
    { Header: "First Name", accessor: "firstName", width: "15%" },
    { Header: "Last Name", accessor: "lastName", width: "15%" },
    { Header: "Roll Number", accessor: "extra.rollNumber", width: "15%" },
    { Header: "RFID Number", accessor: "rfidTag", width: "15%" },
    { Header: "Standard", accessor: "extra.standard", width: "10%" },
    { Header: "Guardian Numbers", accessor: "extra.guardians", width: "15%" },
    { Header: "Address", accessor: "address", width: "20%" },
  ];

  // Function to validate and create account data from Excel
  const createAccountData = (datas) => {
    let dataSource = [];
    let invalid = "";
    let index = 0;
    let dataIndex = 0;

    _.map(datas, (json) => {
      dataIndex += 1;
      let record = { extra: {} };

      record.firstName = json["First Name"];
      record.lastName = json["Last Name"];

      if (_.size(json["Admission No"]) < 2) {
        console.log(`Admission number missing at row ${dataIndex}`);
        setErrorMessage(`Admission number missing at row ${dataIndex}`);
        invalid += `${dataIndex}, `;
        return;
      }
      if (_.size(json.Role) < 2 || !roles.includes(json.Role)) {
        console.log(`Account role is missing or invalid at row ${dataIndex}`);
        setErrorMessage(`Account role is missing or invalid at row ${dataIndex}`);
        invalid += `${dataIndex}, `;
        return;
      }

      record.accountId = json["Admission No"];
      record.role = json.Role.toUpperCase();
      record.rfidTag = json["RFID Number"];
      record.extra.rollNumber = json["Roll Number"];
      record.extra.standard = json.Standard;
      record.address = json.Address;
      record.extra.guardians = [];

      if (["DRIVER", "ATTENDANT", "STAFF"].includes(record.role)) {
        if (isPhoneNumber(record.accountId) && _.size(record.accountId) === 10) {
          record.phoneNumber = `91${record.accountId}`;
          record.accountId = record.phoneNumber;
        }
        let g = record.extra.guardians;
        if (record.role === "STAFF" && isPhoneNumber(record.phoneNumber) && !g.includes(record.phoneNumber)) {
          g.push(record.phoneNumber);
          record.extra.guardians = g;
        }
      }

      if (json["Guardian Numbers"]) {
        let numbers = json["Guardian Numbers"].split(";");
        let numberInvalid = false;
        numbers.forEach((number) => {
          number = number.replace(/\s+/, "");
          if (number.length === 10) {
            number = `91${number}`;
          }
          if (number.length === 12 && isPhoneNumber(number)) {
            if (!record.extra.guardians.includes(number)) {
              record.extra.guardians.push(number);
            }
          } else {
            numberInvalid = true;
          }
        });

        if (numberInvalid) {
          console.log(`Invalid guardian number at row ${dataIndex}`);
          setErrorMessage(`Invalid guardian number at row ${dataIndex}`);
          invalid += `${dataIndex}, `;
          return;
        }
      }
      dataSource[index] = record;
      index += 1;
    });

    if (_.size(invalid) > 0) {
      setErrorMessage(`Invalid rows found - ${invalid}`);
      return null;
    }
    return dataSource;
  };

  // Function to handle file upload
  const onUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    let reader = new FileReader();
    reader.onload = (e) => {
      setUploadResult(null);
      let data = e.target.result;
      let workbook = XLSX.read(data, { type: "binary" });
      let datas = [];
      let dataJson = [];
      workbook.SheetNames.forEach((sheetName) => {
        dataJson = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
        if (sheetName === "Students") {
          datas.Students = dataJson;
        }
      });

      let students = createAccountData(datas.Students);
      if (students) {
        setAccountDataSource(students);
        setErrorMessage("");
      } else {
        setAccountDataSource([]);
      }
    };
    reader.readAsBinaryString(file);
  };

  // Function to handle download template
  const handleDownloadTemplate = () => {
    const worksheetData = [
      [
        "Admission No",
        "Role",
        "First Name",
        "Last Name",
        "Roll Number",
        "RFID Number",
        "Standard",
        "Guardian Numbers",
        "Address",
      ],
      [
        "18PC010010",
        "STUDENT",
        "Arun",
        "Naik",
        "18PC010010",
        "12345678",
        "Grade V",
        "9645274915;9876543213",
        "Bits Pilani, Hyderabad",
      ],
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Students");

    XLSX.writeFile(workbook, "Student-Data-Upload-Template.xlsx");
  };
  const handleSubmitChanges = async () => {
    if (accountDataSource.length === 0) {
      setErrorMessage("No valid data to submit.");
      openErrorSB();
      return;
    }
  
    // Construct payload to match the reference handleSubmit structure
    const payload = {
      accounts: accountDataSource.map((item) => ({
        accountId: item.accountId,
        firstName: item.firstName,
        lastName: item.lastName,
        role: item.role,
        address: item.address,
        rfidTag: item.rfidTag || null,
        extra: {
          standard: item.extra.standard,
          rollNumber: item.extra.rollNumber,
          guardians: item.extra.guardians || [],
        },
      })),
    };
  
    try {
      const sessionCode = localStorage.getItem("token");
      if (!sessionCode) {
        throw new Error("Session code is missing");
      }
  
      const response = await axios.post(updateaccount, payload, {
        headers: {
          "Content-Type": "application/json",
          "x-dhundhoo-session": sessionCode,
        },
      });
  
      if (response.status === 200) {
        const data = response.data || {};
        const skippedRfids = data.skippedRfids || {};
        const hasSkipped = Object.keys(skippedRfids).length > 0;

        setUploadResult({
          message: data.message || "Accounts saved.",
          skippedRfids,
        });
        setErrorMessage("");
        // Full success -> snackbar; partial success -> warning panel below
        if (!hasSkipped) openSuccessSB();
        setAccountDataSource([]); // Clear the table after successful submission
      } else {
        console.error("API Error", response);
        setErrorMessage("Unexpected response from server.");
        openErrorSB();
      }
    } catch (error) {
      console.error("API Request Failed", error);
      setUploadResult(null);
      setErrorMessage(
        error?.response?.data?.message || "Failed to submit data. Please try again."
      );
      openErrorSB();
    }
  };
  // Function to handle submit changes with API call
//   const handleSubmitChanges = async () => {
//     if (accountDataSource.length === 0) {
//       setErrorMessage("No valid data to submit.");
//       openErrorSB();
//       return;
//     }

//     let payload = accountDataSource.map((item) => item.accountId);

//     try {
//       const sessionCode = localStorage.getItem("token");
//       if (!sessionCode) {
//         throw new Error("Session code is missing");
//       }

//       const response = await axios.post(updateaccount, payload, {
//         headers: {
//           "Content-Type": "application/json",
//           "x-dhundhoo-session": sessionCode,
//         },
//       });

//       if (response.status === 200) {
//         openSuccessSB();
//         setAccountDataSource([]); // Clear the table after successful deletion
//       } else {
//         console.error("API Error", response);
//         openErrorSB();
//       }
//     } catch (error) {
//       console.error("API Request Failed", error);
//       openErrorSB();
//     }
//   };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                borderRadius="lg"
                coloredShadow="info"
              >
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    gap: 2,
                    justifyContent: "space-around"
                    // mt: 3,
                  }}
                >
                  <MDButton
                    variant="gradient"
                    color="info"
                    onClick={handleDownloadTemplate}
                  >
                    Download Template
                  </MDButton>

                  <MDButton
                    variant="gradient"
                    color="info"
                    component="label"
                  >
                    Upload Data Sheet
                    <input
                      type="file"
                      accept=".xlsx"
                      hidden
                      onChange={onUpload}
                    />
                  </MDButton>

                  <MDButton
                    variant="gradient"
                    color="info"
                    onClick={handleSubmitChanges}
                  >
                    Submit Changes
                  </MDButton>
                </Grid>
              </MDBox>

              {errorMessage && (
                <MDBox px={2} pt={2}>
                  <Alert severity="error">{errorMessage}</Alert>
                </MDBox>
              )}

              {uploadResult && (
                <MDBox px={2} pt={2}>
                  <Alert
                    severity={
                      Object.keys(uploadResult.skippedRfids).length > 0 ? "warning" : "success"
                    }
                    onClose={() => setUploadResult(null)}
                  >
                    <AlertTitle>{uploadResult.message}</AlertTitle>
                    {Object.keys(uploadResult.skippedRfids).length > 0 && (
                      <>
                        Skipped RFIDs ({Object.keys(uploadResult.skippedRfids).length}):
                        <ul style={{ margin: "4px 0 0", paddingLeft: 20 }}>
                          {Object.entries(uploadResult.skippedRfids).map(([rfid, reason]) => (
                            <li key={rfid}>
                              <strong>{rfid}</strong>: {String(reason)}
                            </li>
                          ))}
                        </ul>
                      </>
                    )}
                  </Alert>
                </MDBox>
              )}

              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows: accountDataSource }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {renderSuccessSB}
      {renderErrorSB}
    </DashboardLayout>
  );
}

export default BulkStudentUpload;